import { HStack, Spacer, Stack } from "@chakra-ui/react"
import { Text } from "@/components"
import { useAuth } from "@/contexts"
import { NdaFormComponent } from "./components"

export const NdaComponent = () => {
  const { user } = useAuth()

  if (!user) return null
  if (user.userType !== "client") return null

  return (
    <HStack bg="sidebar.bg">
      <Stack h="100vh" w="40%" p={10} bg="sidebar.bg">
        <Text fontSize="lg" fontWeight="bold" fontFamily="body" color="white" mb={10}>
          ESO Fund Client Portal
        </Text>
        <Text fontSize="xs" fontFamily="body" color="white">
          Your Equity Partner
        </Text>
        <Spacer />
      </Stack>
      <NdaFormComponent isInitialScreen={true} />
    </HStack>
  )
}
